/**
 * 保单状态
 */
export const POLICY_STATUS = {
  CLOSED: 'closed',
  PENDING: 'pending',
  EXPIRED: 'expired',
  EXPIRE: 'expire',
  CANCELLED: 'cancelled',
  ACTIVE: 'active',
  SURRENDER: 'surrender',
};
export const POLICY_STATUS_TEXT = {
  [POLICY_STATUS.CLOSED]: 'Closed',
  [POLICY_STATUS.PENDING]: 'Pending',
  [POLICY_STATUS.EXPIRED]: 'Expired',
  [POLICY_STATUS.EXPIRE]: 'Expired',
  [POLICY_STATUS.CANCELLED]: 'Cancelled',
  [POLICY_STATUS.ACTIVE]: 'Active',
  [POLICY_STATUS.SURRENDER]: 'Cancelled',
};
export const POLICY_STATUS_COLOR_MAP = {
  [POLICY_STATUS.CLOSED]: '#AEE9D1',
  [POLICY_STATUS.PENDING]: '#FFEA8A',
  [POLICY_STATUS.EXPIRED]: '#E4E5E7',
  [POLICY_STATUS.EXPIRE]: '#E4E5E7',
  [POLICY_STATUS.CANCELLED]: '#E1E2E2',
  [POLICY_STATUS.ACTIVE]: '#C8C5FF',
  [POLICY_STATUS.SURRENDER]: '#E1E2E2',

};

/** claim 的 3 种状态 */
export const CLAIM_STATUS = {
  PENDING: 'pending',
  ACCEPT: 'accept',
  REJECT: 'reject',
  PROCESS: 'In Progress',
};
/** claim 状态的文案 */
export const CLAIM_STATUS_TEXT = {
  [CLAIM_STATUS.ACCEPT]: 'Accepted',
  [CLAIM_STATUS.PENDING]: 'Pending',
  [CLAIM_STATUS.REJECT]: 'Rejected',
  [CLAIM_STATUS.PROCESS]: 'In Progress',
  Accepted: 'Accepted',
  Rejected: 'Rejected',
};
/** claim 状态的背景色 */
export const CLAIM_STATUS_BACKGROUTD = {
  [CLAIM_STATUS.ACCEPT]: '#AEE9D1',
  [CLAIM_STATUS.PENDING]: '#FFEA8A',
  [CLAIM_STATUS.REJECT]: '#FFD79D',
  [CLAIM_STATUS.PROCESS]: '#FFEA8A',
  Accepted: '#AEE9D1',
  Rejected: '#FFD79D',
};

/** 产品类型 */
export const PRODUCT_TYPE = {
  /** Return Assurance */
  Return: 'RA',
  /** Buyer Protection */
  Buyer: 'BP',
  /** Assured Sale */
  Assured: 'AS',
  Extended: 'EW',
  All: 'all',
};
